import React from 'react';
import PropTypes from 'prop-types';
import { components } from '@glowforge/ui-common';
import classNames from 'classnames';
import { textPropTypes } from 'app/selectors/support';

import './entries.less';

const { Markdown } = components;

const MultiStepTextEntry = ({
  steps,
}) => (
  steps.map((step) => {
    const { stepNumber, text } = step.fields;
    return (
      <div className={classNames('textSection', {
        withStep: stepNumber,
      })}>
        <p className='stepNumber'>{stepNumber}</p>
        <Markdown className='text paragraph stepText' source={text} />
      </div>
    );
  })
);

MultiStepTextEntry.propTypes = {
  steps: PropTypes.arrayOf(...textPropTypes).isRequired,
};

export default MultiStepTextEntry;



// WEBPACK FOOTER //
// ./app/components/support/entries/multi-step-text-entry.jsx